import React from 'react'

import './index.scss'

export const PeopleIcon: React.FC<{
  className: string
}> = ({ className }) => (
  <svg
    className={['icon', 'icon--people', className].filter(Boolean).join(' ')}
    height="14"
    viewBox="0 0 16 14"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="stroke"
      d="M12.0002 13C12.0002 11.5855 11.4383 10.229 10.4381 9.22876C9.43787 8.22857 8.08132 7.66667 6.66683 7.66667M6.66683 7.66667C5.25234 7.66667 3.89579 8.22857 2.89559 9.22876C1.8954 10.229 1.3335 11.5855 1.3335 13M6.66683 7.66667C8.50778 7.66667 10.0002 6.17428 10.0002 4.33333C10.0002 2.49238 8.50778 1 6.66683 1C4.82588 1 3.3335 2.49238 3.3335 4.33333C3.3335 6.17428 4.82588 7.66667 6.66683 7.66667ZM14.6668 12.3333C14.6668 10.0867 13.3335 8 12.0002 7C12.4384 6.67118 12.7889 6.23939 13.0205 5.74285C13.2522 5.2463 13.3578 4.70031 13.3282 4.1532C13.2985 3.60609 13.1344 3.07472 12.8505 2.60613C12.5665 2.13754 12.1714 1.74617 11.7002 1.46667"
      strokeLinecap="square"
    />
  </svg>
)
